/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type BsShopIntegrationData,
    BsShopIntegrationDataFromJSON,
    BsShopIntegrationDataToJSON,
} from '../models/BsShopIntegrationData';
import {
    type BsShopIntegrationInput,
    BsShopIntegrationInputFromJSON,
    BsShopIntegrationInputToJSON,
} from '../models/BsShopIntegrationInput';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type GlamiIntegrationData,
    GlamiIntegrationDataFromJSON,
    GlamiIntegrationDataToJSON,
} from '../models/GlamiIntegrationData';
import {
    type GlamiIntegrationInput,
    GlamiIntegrationInputFromJSON,
    GlamiIntegrationInputToJSON,
} from '../models/GlamiIntegrationInput';
import {
    type GoogleAnalyticsAggregateReportData,
    GoogleAnalyticsAggregateReportDataFromJSON,
    GoogleAnalyticsAggregateReportDataToJSON,
} from '../models/GoogleAnalyticsAggregateReportData';
import {
    type GoogleAnalyticsAttributionApplyInput,
    GoogleAnalyticsAttributionApplyInputFromJSON,
    GoogleAnalyticsAttributionApplyInputToJSON,
} from '../models/GoogleAnalyticsAttributionApplyInput';
import {
    type GoogleAnalyticsAttributionMutationData,
    GoogleAnalyticsAttributionMutationDataFromJSON,
    GoogleAnalyticsAttributionMutationDataToJSON,
} from '../models/GoogleAnalyticsAttributionMutationData';
import {
    type GoogleAnalyticsAttributionShadowPreviewData,
    GoogleAnalyticsAttributionShadowPreviewDataFromJSON,
    GoogleAnalyticsAttributionShadowPreviewDataToJSON,
} from '../models/GoogleAnalyticsAttributionShadowPreviewData';
import {
    type GoogleAnalyticsPropertyData,
    GoogleAnalyticsPropertyDataFromJSON,
    GoogleAnalyticsPropertyDataToJSON,
} from '../models/GoogleAnalyticsPropertyData';
import {
    type GoogleBigQueryGa4PseudonymousUsersReportData,
    GoogleBigQueryGa4PseudonymousUsersReportDataFromJSON,
    GoogleBigQueryGa4PseudonymousUsersReportDataToJSON,
} from '../models/GoogleBigQueryGa4PseudonymousUsersReportData';
import {
    type GoogleBigQueryGa4ReportData,
    GoogleBigQueryGa4ReportDataFromJSON,
    GoogleBigQueryGa4ReportDataToJSON,
} from '../models/GoogleBigQueryGa4ReportData';
import {
    type GoogleBigQueryRecipeInput,
    GoogleBigQueryRecipeInputFromJSON,
    GoogleBigQueryRecipeInputToJSON,
} from '../models/GoogleBigQueryRecipeInput';
import {
    type GoogleBigQueryRecipeValidationData,
    GoogleBigQueryRecipeValidationDataFromJSON,
    GoogleBigQueryRecipeValidationDataToJSON,
} from '../models/GoogleBigQueryRecipeValidationData';
import {
    type GoogleBigQueryResourceData,
    GoogleBigQueryResourceDataFromJSON,
    GoogleBigQueryResourceDataToJSON,
} from '../models/GoogleBigQueryResourceData';
import {
    type GoogleCrossSystemReportData,
    GoogleCrossSystemReportDataFromJSON,
    GoogleCrossSystemReportDataToJSON,
} from '../models/GoogleCrossSystemReportData';
import {
    type GoogleFactOwnershipDiagnosticsData,
    GoogleFactOwnershipDiagnosticsDataFromJSON,
    GoogleFactOwnershipDiagnosticsDataToJSON,
} from '../models/GoogleFactOwnershipDiagnosticsData';
import {
    type GoogleFactOwnershipTransitionData,
    GoogleFactOwnershipTransitionDataFromJSON,
    GoogleFactOwnershipTransitionDataToJSON,
} from '../models/GoogleFactOwnershipTransitionData';
import {
    type GoogleFactOwnershipTransitionInput,
    GoogleFactOwnershipTransitionInputFromJSON,
    GoogleFactOwnershipTransitionInputToJSON,
} from '../models/GoogleFactOwnershipTransitionInput';
import {
    type GoogleIntegrationUsageData,
    GoogleIntegrationUsageDataFromJSON,
    GoogleIntegrationUsageDataToJSON,
} from '../models/GoogleIntegrationUsageData';
import {
    type GoogleLandingPageFunnelData,
    GoogleLandingPageFunnelDataFromJSON,
    GoogleLandingPageFunnelDataToJSON,
} from '../models/GoogleLandingPageFunnelData';
import {
    type GoogleMerchantAccountData,
    GoogleMerchantAccountDataFromJSON,
    GoogleMerchantAccountDataToJSON,
} from '../models/GoogleMerchantAccountData';
import {
    type GoogleMerchantCatalogHealthData,
    GoogleMerchantCatalogHealthDataFromJSON,
    GoogleMerchantCatalogHealthDataToJSON,
} from '../models/GoogleMerchantCatalogHealthData';
import {
    type GoogleMerchantCatalogProductPageData,
    GoogleMerchantCatalogProductPageDataFromJSON,
    GoogleMerchantCatalogProductPageDataToJSON,
} from '../models/GoogleMerchantCatalogProductPageData';
import {
    type GoogleMerchantMarketReportData,
    GoogleMerchantMarketReportDataFromJSON,
    GoogleMerchantMarketReportDataToJSON,
} from '../models/GoogleMerchantMarketReportData';
import {
    type GoogleMerchantPriceReportData,
    GoogleMerchantPriceReportDataFromJSON,
    GoogleMerchantPriceReportDataToJSON,
} from '../models/GoogleMerchantPriceReportData';
import {
    type GoogleMerchantProductMappingData,
    GoogleMerchantProductMappingDataFromJSON,
    GoogleMerchantProductMappingDataToJSON,
} from '../models/GoogleMerchantProductMappingData';
import {
    type GoogleMerchantProductMappingInput,
    GoogleMerchantProductMappingInputFromJSON,
    GoogleMerchantProductMappingInputToJSON,
} from '../models/GoogleMerchantProductMappingInput';
import {
    type GoogleOAuthAuthorizationData,
    GoogleOAuthAuthorizationDataFromJSON,
    GoogleOAuthAuthorizationDataToJSON,
} from '../models/GoogleOAuthAuthorizationData';
import {
    type GoogleSearchConsoleBrandPreviewInput,
    GoogleSearchConsoleBrandPreviewInputFromJSON,
    GoogleSearchConsoleBrandPreviewInputToJSON,
} from '../models/GoogleSearchConsoleBrandPreviewInput';
import {
    type GoogleSearchConsoleBrandReportData,
    GoogleSearchConsoleBrandReportDataFromJSON,
    GoogleSearchConsoleBrandReportDataToJSON,
} from '../models/GoogleSearchConsoleBrandReportData';
import {
    type GoogleSearchConsoleBrandRuleSetData,
    GoogleSearchConsoleBrandRuleSetDataFromJSON,
    GoogleSearchConsoleBrandRuleSetDataToJSON,
} from '../models/GoogleSearchConsoleBrandRuleSetData';
import {
    type GoogleSearchConsoleBrandRuleSetInput,
    GoogleSearchConsoleBrandRuleSetInputFromJSON,
    GoogleSearchConsoleBrandRuleSetInputToJSON,
} from '../models/GoogleSearchConsoleBrandRuleSetInput';
import {
    type GoogleSearchConsoleCannibalizationPageData,
    GoogleSearchConsoleCannibalizationPageDataFromJSON,
    GoogleSearchConsoleCannibalizationPageDataToJSON,
} from '../models/GoogleSearchConsoleCannibalizationPageData';
import {
    type GoogleSearchConsoleReportData,
    GoogleSearchConsoleReportDataFromJSON,
    GoogleSearchConsoleReportDataToJSON,
} from '../models/GoogleSearchConsoleReportData';
import {
    type GoogleSearchConsoleSiteData,
    GoogleSearchConsoleSiteDataFromJSON,
    GoogleSearchConsoleSiteDataToJSON,
} from '../models/GoogleSearchConsoleSiteData';
import {
    type GoogleSearchConsoleUrlInspectionBatchData,
    GoogleSearchConsoleUrlInspectionBatchDataFromJSON,
    GoogleSearchConsoleUrlInspectionBatchDataToJSON,
} from '../models/GoogleSearchConsoleUrlInspectionBatchData';
import {
    type GoogleSearchConsoleUrlInspectionInput,
    GoogleSearchConsoleUrlInspectionInputFromJSON,
    GoogleSearchConsoleUrlInspectionInputToJSON,
} from '../models/GoogleSearchConsoleUrlInspectionInput';
import {
    type GoogleSearchConsoleUrlInspectionRowData,
    GoogleSearchConsoleUrlInspectionRowDataFromJSON,
    GoogleSearchConsoleUrlInspectionRowDataToJSON,
} from '../models/GoogleSearchConsoleUrlInspectionRowData';
import {
    type HeurekaIntegrationData,
    HeurekaIntegrationDataFromJSON,
    HeurekaIntegrationDataToJSON,
} from '../models/HeurekaIntegrationData';
import {
    type HeurekaIntegrationInput,
    HeurekaIntegrationInputFromJSON,
    HeurekaIntegrationInputToJSON,
} from '../models/HeurekaIntegrationInput';
import {
    type ListProjectIntegrations200ResponseInner,
    ListProjectIntegrations200ResponseInnerFromJSON,
    ListProjectIntegrations200ResponseInnerToJSON,
} from '../models/ListProjectIntegrations200ResponseInner';
import {
    type MySQLLeadIntegrationData,
    MySQLLeadIntegrationDataFromJSON,
    MySQLLeadIntegrationDataToJSON,
} from '../models/MySQLLeadIntegrationData';
import {
    type MySQLLeadIntegrationInput,
    MySQLLeadIntegrationInputFromJSON,
    MySQLLeadIntegrationInputToJSON,
} from '../models/MySQLLeadIntegrationInput';
import {
    type ShoptetIntegrationData,
    ShoptetIntegrationDataFromJSON,
    ShoptetIntegrationDataToJSON,
} from '../models/ShoptetIntegrationData';
import {
    type ShoptetIntegrationInput,
    ShoptetIntegrationInputFromJSON,
    ShoptetIntegrationInputToJSON,
} from '../models/ShoptetIntegrationInput';
import {
    type SklikIntegrationData,
    SklikIntegrationDataFromJSON,
    SklikIntegrationDataToJSON,
} from '../models/SklikIntegrationData';
import {
    type SklikIntegrationInput,
    SklikIntegrationInputFromJSON,
    SklikIntegrationInputToJSON,
} from '../models/SklikIntegrationInput';
import {
    type UpdateGoogleMerchantMarketReportSettingsRequest,
    UpdateGoogleMerchantMarketReportSettingsRequestFromJSON,
    UpdateGoogleMerchantMarketReportSettingsRequestToJSON,
} from '../models/UpdateGoogleMerchantMarketReportSettingsRequest';
import {
    type UpgatesIntegrationData,
    UpgatesIntegrationDataFromJSON,
    UpgatesIntegrationDataToJSON,
} from '../models/UpgatesIntegrationData';
import {
    type UpgatesIntegrationInput,
    UpgatesIntegrationInputFromJSON,
    UpgatesIntegrationInputToJSON,
} from '../models/UpgatesIntegrationInput';
import {
    type ZboziIntegrationData,
    ZboziIntegrationDataFromJSON,
    ZboziIntegrationDataToJSON,
} from '../models/ZboziIntegrationData';
import {
    type ZboziIntegrationInput,
    ZboziIntegrationInputFromJSON,
    ZboziIntegrationInputToJSON,
} from '../models/ZboziIntegrationInput';

export interface ApplyGoogleAnalyticsAttributionFallbackRequest {
    projectId: string;
    googleAnalyticsAttributionApplyInput: GoogleAnalyticsAttributionApplyInput;
}

export interface AuthenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest {
    projectId: string;
    authorization: string;
    integrationId?: string;
}

export interface AuthenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest {
    projectId: string;
    authorization: string;
    integrationId?: string;
}

export interface AuthenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest {
    projectId: string;
    authorization: string;
    integrationId?: string;
}

export interface AuthenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest {
    projectId: string;
    authorization: string;
    integrationId?: string;
}

export interface AuthenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest {
    projectId: string;
    authorization: string;
    integrationId?: string;
}

export interface AuthenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest {
    projectId: string;
    authorization: string;
    integrationId?: string;
}

export interface BSShopIntegrationRequest {
    projectId: string;
    integrationId?: string;
    bsShopIntegrationInput?: BsShopIntegrationInput;
}

export interface ChooseCriteoAdAccountsRequest {
    projectId: string;
    integrationId: string;
    requestBody?: Array<string>;
}

export interface ChooseGoogleCustomerClientsRequest {
    projectId: string;
    integrationId: string;
    requestBody?: Array<string>;
}

export interface ChooseMetaAdAccountsRequest {
    projectId: string;
    integrationId: string;
    requestBody?: Array<string>;
}

export interface ChooseMicrosoftAdAccountsRequest {
    projectId: string;
    integrationId: string;
    requestBody?: Array<string>;
}

export interface ChoosePinterestAdAccountsRequest {
    projectId: string;
    integrationId: string;
    requestBody?: Array<string>;
}

export interface ChooseTikTokAdAccountsRequest {
    projectId: string;
    integrationId: string;
    requestBody?: Array<string>;
}

export interface ConfirmGoogleMerchantProductMappingRequest {
    projectId: string;
    integrationId: string;
    accountId: string;
    productIdentityKey: string;
    googleMerchantProductMappingInput: GoogleMerchantProductMappingInput;
}

export interface CreateGoogleSearchConsoleBrandRuleRevisionRequest {
    projectId: string;
    integrationId: string;
    googleSearchConsoleBrandRuleSetInput: GoogleSearchConsoleBrandRuleSetInput;
}

export interface DeleteProjectIntegrationRequest {
    projectId: string;
    integrationId: string;
}

export interface DisconnectGoogleDataIntegrationRequest {
    projectId: string;
    integrationId: string;
}

export interface DiscoverGoogleAnalyticsPropertiesRequest {
    projectId: string;
    integrationId: string;
}

export interface DiscoverGoogleBigQueryDatasetsRequest {
    projectId: string;
    integrationId: string;
    dataProjectId: string;
}

export interface DiscoverGoogleBigQueryProjectsRequest {
    projectId: string;
    integrationId: string;
}

export interface DiscoverGoogleMerchantAccountsRequest {
    projectId: string;
    integrationId: string;
}

export interface DiscoverGoogleMerchantSubaccountsRequest {
    projectId: string;
    integrationId: string;
    accountId: string;
}

export interface DiscoverGoogleSearchConsoleSitesRequest {
    projectId: string;
    integrationId: string;
}

export interface GetGoogleDataIntegrationUsageRequest {
    projectId: string;
    integrationId: string;
}

export interface GetGoogleMerchantMarketReportSettingsRequest {
    projectId: string;
    integrationId: string;
    accountId: string;
}

export interface GlamiIntegrationRequest {
    projectId: string;
    integrationId?: string;
    glamiIntegrationInput?: GlamiIntegrationInput;
}

export interface GoogleAnalyticsAggregateReportRequest {
    projectId: string;
    integrationId: string;
    propertyId: string;
    recipe: GoogleAnalyticsAggregateReportRecipeEnum;
    since: Date;
    until: Date;
}

export interface GoogleAnalyticsAttributionShadowPreviewRequest {
    projectId: string;
    since: Date;
    until: Date;
}

export interface GoogleBigQueryGA4ExportReportRequest {
    projectId: string;
    integrationId: string;
    recipeId: string;
    since: Date;
    until: Date;
}

export interface GoogleBigQueryGA4PseudonymousUsersReportRequest {
    projectId: string;
    integrationId: string;
    since: Date;
    until: Date;
}

export interface GoogleDataCrossSystemReportRequest {
    projectId: string;
    since: Date;
    until: Date;
}

export interface GoogleDataSourceOwnershipDiagnosticsRequest {
    projectId: string;
}

export interface GoogleLandingPageFunnelRequest {
    projectId: string;
    searchConsoleIntegrationId: string;
    searchConsoleSiteId: string;
    analyticsIntegrationId: string;
    analyticsPropertyId: string;
    since: Date;
    until: Date;
    page?: number;
    limit?: number;
    search?: string;
}

export interface GoogleMerchantCatalogueHealthRequest {
    projectId: string;
    integrationId: string;
    accountId: string;
}

export interface GoogleMerchantCatalogueProductsRequest {
    projectId: string;
    integrationId: string;
    accountId: string;
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: GoogleMerchantCatalogueProductsSortByEnum;
    sortDirection?: GoogleMerchantCatalogueProductsSortDirectionEnum;
}

export interface GoogleMerchantMarketReportsRequest {
    projectId: string;
    integrationId: string;
    accountId: string;
}

export interface GoogleMerchantPriceReportsRequest {
    projectId: string;
    integrationId: string;
    accountId: string;
}

export interface GoogleSearchConsoleBrandReportRequest {
    projectId: string;
    integrationId: string;
    siteId: string;
    since: Date;
    until: Date;
}

export interface GoogleSearchConsoleBrandRulesRequest {
    projectId: string;
    integrationId: string;
}

export interface GoogleSearchConsoleCannibalizationReportRequest {
    projectId: string;
    integrationId: string;
    siteId: string;
    since: Date;
    until: Date;
    page?: number;
    limit?: number;
    search?: string;
}

export interface GoogleSearchConsoleReportRequest {
    projectId: string;
    integrationId: string;
    siteId: string;
    recipe: GoogleSearchConsoleReportRecipeEnum;
    since: Date;
    until: Date;
}

export interface GoogleSearchConsoleURLInspectionsRequest {
    projectId: string;
    integrationId: string;
    siteId: string;
}

export interface HeurekaIntegrationRequest {
    projectId: string;
    integrationId?: string;
    heurekaIntegrationInput?: HeurekaIntegrationInput;
}

export interface InspectGoogleSearchConsoleURLsRequest {
    projectId: string;
    integrationId: string;
    siteId: string;
    googleSearchConsoleUrlInspectionInput: GoogleSearchConsoleUrlInspectionInput;
}

export interface InstallGoogleDataIntegrationRequest {
    projectId: string;
    type: InstallGoogleDataIntegrationTypeEnum;
}

export interface ListProjectIntegrationsRequest {
    projectId: string;
}

export interface MySQLLeadIntegrationRequest {
    projectId: string;
    integrationId?: string;
    mySQLLeadIntegrationInput?: MySQLLeadIntegrationInput;
}

export interface PauseProjectIntegrationRequest {
    projectId: string;
    integrationId: string;
}

export interface PreviewGoogleSearchConsoleBrandReportRequest {
    projectId: string;
    integrationId: string;
    siteId: string;
    googleSearchConsoleBrandPreviewInput: GoogleSearchConsoleBrandPreviewInput;
}

export interface RefreshProjectOAuthIntegrationResourcesRequest {
    projectId: string;
    integrationId: string;
}

export interface ResumeProjectIntegrationRequest {
    projectId: string;
    integrationId: string;
}

export interface RollbackGoogleAnalyticsAttributionFallbackRequest {
    projectId: string;
    revisionId: string;
}

export interface RollbackGoogleDataSourceOwnershipRequest {
    projectId: string;
    transitionId: string;
    effectiveFrom: Date;
}

export interface SelectGoogleAnalyticsPropertiesRequest {
    projectId: string;
    integrationId: string;
    requestBody: Array<string>;
}

export interface SelectGoogleMerchantAccountsRequest {
    projectId: string;
    integrationId: string;
    requestBody: Array<string>;
}

export interface SelectGoogleSearchConsoleSitesRequest {
    projectId: string;
    integrationId: string;
    requestBody: Array<string>;
}

export interface ShoptetIntegrationRequest {
    projectId: string;
    integrationId?: string;
    shoptetIntegrationInput?: ShoptetIntegrationInput;
}

export interface SklikIntegrationRequest {
    projectId: string;
    integrationId?: string;
    sklikIntegrationInput?: SklikIntegrationInput;
}

export interface StartGoogleDataIntegrationOAuthRequest {
    projectId: string;
    integrationId: string;
}

export interface TransitionGoogleDataSourceOwnershipRequest {
    projectId: string;
    googleFactOwnershipTransitionInput: GoogleFactOwnershipTransitionInput;
}

export interface UpdateGoogleMerchantMarketReportSettingsOperationRequest {
    projectId: string;
    integrationId: string;
    accountId: string;
    updateGoogleMerchantMarketReportSettingsRequest: UpdateGoogleMerchantMarketReportSettingsRequest;
}

export interface UpgatesIntegrationRequest {
    projectId: string;
    integrationId?: string;
    upgatesIntegrationInput?: UpgatesIntegrationInput;
}

export interface ValidateAndSelectGoogleBigQueryGA4ExportRecipeRequest {
    projectId: string;
    integrationId: string;
    googleBigQueryRecipeInput: GoogleBigQueryRecipeInput;
}

export interface ZboziIntegrationRequest {
    projectId: string;
    integrationId?: string;
    zboziIntegrationInput?: ZboziIntegrationInput;
}

/**
 * 
 */
export class ProjectIntegrationsApi extends runtime.BaseAPI {

    /**
     * Creates request options for applyGoogleAnalyticsAttributionFallback without sending the request
     */
    async applyGoogleAnalyticsAttributionFallbackRequestOpts(requestParameters: ApplyGoogleAnalyticsAttributionFallbackRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling applyGoogleAnalyticsAttributionFallback().'
            );
        }

        if (requestParameters['googleAnalyticsAttributionApplyInput'] == null) {
            throw new runtime.RequiredError(
                'googleAnalyticsAttributionApplyInput',
                'Required parameter "googleAnalyticsAttributionApplyInput" was null or undefined when calling applyGoogleAnalyticsAttributionFallback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-analytics/attribution-fallback`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GoogleAnalyticsAttributionApplyInputToJSON(requestParameters['googleAnalyticsAttributionApplyInput']),
        };
    }

    /**
     * Applies one explicitly selected, exact GA4 transaction fallback only when no stronger attribution exists and the Google Ads account and campaign resolve unambiguously. The mutation is audited and reversible.
     */
    async applyGoogleAnalyticsAttributionFallbackRaw(requestParameters: ApplyGoogleAnalyticsAttributionFallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleAnalyticsAttributionMutationData>> {
        const requestOptions = await this.applyGoogleAnalyticsAttributionFallbackRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleAnalyticsAttributionMutationDataFromJSON(jsonValue));
    }

    /**
     * Applies one explicitly selected, exact GA4 transaction fallback only when no stronger attribution exists and the Google Ads account and campaign resolve unambiguously. The mutation is audited and reversible.
     */
    async applyGoogleAnalyticsAttributionFallback(requestParameters: ApplyGoogleAnalyticsAttributionFallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleAnalyticsAttributionMutationData> {
        const response = await this.applyGoogleAnalyticsAttributionFallbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebApp without sending the request
     */
    async authenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters: AuthenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling authenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling authenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        if (requestParameters['authorization'] != null) {
            queryParameters['authorization'] = requestParameters['authorization'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations/criteo`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Redirects user to Criteo consent.
     */
    async authenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters: AuthenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Redirects user to Criteo consent.
     */
    async authenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebApp(requestParameters: AuthenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticateProjectCriteoIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebApp without sending the request
     */
    async authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters: AuthenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        if (requestParameters['authorization'] != null) {
            queryParameters['authorization'] = requestParameters['authorization'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations/google`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Redirects user to the google platform authentication page.
     */
    async authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters: AuthenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Redirects user to the google platform authentication page.
     */
    async authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebApp(requestParameters: AuthenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticateProjectGoogleIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebApp without sending the request
     */
    async authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters: AuthenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        if (requestParameters['authorization'] != null) {
            queryParameters['authorization'] = requestParameters['authorization'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Redirects user to the meta platform authentication page.
     */
    async authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters: AuthenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Redirects user to the meta platform authentication page.
     */
    async authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebApp(requestParameters: AuthenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticateProjectMetaIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebApp without sending the request
     */
    async authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters: AuthenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        if (requestParameters['authorization'] != null) {
            queryParameters['authorization'] = requestParameters['authorization'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations/microsoft`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Redirects user to the microsoft platform authentication page.
     */
    async authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters: AuthenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Redirects user to the microsoft platform authentication page.
     */
    async authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebApp(requestParameters: AuthenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticateProjectMicrosoftAdvertisingIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for authenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebApp without sending the request
     */
    async authenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters: AuthenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling authenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling authenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        if (requestParameters['authorization'] != null) {
            queryParameters['authorization'] = requestParameters['authorization'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations/pinterest`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Redirects user to Pinterest OAuth.
     */
    async authenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters: AuthenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Redirects user to Pinterest OAuth.
     */
    async authenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebApp(requestParameters: AuthenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticateProjectPinterestIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for authenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebApp without sending the request
     */
    async authenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters: AuthenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling authenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling authenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebApp().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        if (requestParameters['authorization'] != null) {
            queryParameters['authorization'] = requestParameters['authorization'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations/tiktok`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Redirects user to TikTok OAuth.
     */
    async authenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters: AuthenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Redirects user to TikTok OAuth.
     */
    async authenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebApp(requestParameters: AuthenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticateProjectTikTokIntegrationOrFinishTheProcessAndRedirectsBackToWebAppRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for bSShopIntegration without sending the request
     */
    async bSShopIntegrationRequestOpts(requestParameters: BSShopIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling bSShopIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/bs-shop`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BsShopIntegrationInputToJSON(requestParameters['bsShopIntegrationInput']),
        };
    }

    /**
     * Create or update BS Shop integration.
     */
    async bSShopIntegrationRaw(requestParameters: BSShopIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BsShopIntegrationData>> {
        const requestOptions = await this.bSShopIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BsShopIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update BS Shop integration.
     */
    async bSShopIntegration(requestParameters: BSShopIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BsShopIntegrationData> {
        const response = await this.bSShopIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for chooseCriteoAdAccounts without sending the request
     */
    async chooseCriteoAdAccountsRequestOpts(requestParameters: ChooseCriteoAdAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling chooseCriteoAdAccounts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling chooseCriteoAdAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/integration/{integrationId}/criteo/choose-ad-accounts`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseCriteoAdAccountsRaw(requestParameters: ChooseCriteoAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.chooseCriteoAdAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseCriteoAdAccounts(requestParameters: ChooseCriteoAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.chooseCriteoAdAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for chooseGoogleCustomerClients without sending the request
     */
    async chooseGoogleCustomerClientsRequestOpts(requestParameters: ChooseGoogleCustomerClientsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling chooseGoogleCustomerClients().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling chooseGoogleCustomerClients().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/integration/{integrationId}/google/choose-customer-clients`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Provide `customerClient` list to enable, others will be disabled.
     */
    async chooseGoogleCustomerClientsRaw(requestParameters: ChooseGoogleCustomerClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.chooseGoogleCustomerClientsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Provide `customerClient` list to enable, others will be disabled.
     */
    async chooseGoogleCustomerClients(requestParameters: ChooseGoogleCustomerClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.chooseGoogleCustomerClientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for chooseMetaAdAccounts without sending the request
     */
    async chooseMetaAdAccountsRequestOpts(requestParameters: ChooseMetaAdAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling chooseMetaAdAccounts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling chooseMetaAdAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/integration/{integrationId}/meta/choose-ad-accounts`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseMetaAdAccountsRaw(requestParameters: ChooseMetaAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.chooseMetaAdAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseMetaAdAccounts(requestParameters: ChooseMetaAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.chooseMetaAdAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for chooseMicrosoftAdAccounts without sending the request
     */
    async chooseMicrosoftAdAccountsRequestOpts(requestParameters: ChooseMicrosoftAdAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling chooseMicrosoftAdAccounts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling chooseMicrosoftAdAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/integration/{integrationId}/microsoft/choose-ad-accounts`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseMicrosoftAdAccountsRaw(requestParameters: ChooseMicrosoftAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.chooseMicrosoftAdAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseMicrosoftAdAccounts(requestParameters: ChooseMicrosoftAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.chooseMicrosoftAdAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for choosePinterestAdAccounts without sending the request
     */
    async choosePinterestAdAccountsRequestOpts(requestParameters: ChoosePinterestAdAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling choosePinterestAdAccounts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling choosePinterestAdAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/integration/{integrationId}/pinterest/choose-ad-accounts`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async choosePinterestAdAccountsRaw(requestParameters: ChoosePinterestAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.choosePinterestAdAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async choosePinterestAdAccounts(requestParameters: ChoosePinterestAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.choosePinterestAdAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for chooseTikTokAdAccounts without sending the request
     */
    async chooseTikTokAdAccountsRequestOpts(requestParameters: ChooseTikTokAdAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling chooseTikTokAdAccounts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling chooseTikTokAdAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/integration/{integrationId}/tiktok/choose-ad-accounts`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseTikTokAdAccountsRaw(requestParameters: ChooseTikTokAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.chooseTikTokAdAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Provide `adAccount` list to enable, others will be disabled.
     */
    async chooseTikTokAdAccounts(requestParameters: ChooseTikTokAdAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.chooseTikTokAdAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for confirmGoogleMerchantProductMapping without sending the request
     */
    async confirmGoogleMerchantProductMappingRequestOpts(requestParameters: ConfirmGoogleMerchantProductMappingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling confirmGoogleMerchantProductMapping().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling confirmGoogleMerchantProductMapping().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling confirmGoogleMerchantProductMapping().'
            );
        }

        if (requestParameters['productIdentityKey'] == null) {
            throw new runtime.RequiredError(
                'productIdentityKey',
                'Required parameter "productIdentityKey" was null or undefined when calling confirmGoogleMerchantProductMapping().'
            );
        }

        if (requestParameters['googleMerchantProductMappingInput'] == null) {
            throw new runtime.RequiredError(
                'googleMerchantProductMappingInput',
                'Required parameter "googleMerchantProductMappingInput" was null or undefined when calling confirmGoogleMerchantProductMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-merchant/{integrationId}/accounts/{accountId}/products/{productIdentityKey}/mapping`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{accountId}', encodeURIComponent(String(requestParameters['accountId'])));
        urlPath = urlPath.replace('{productIdentityKey}', encodeURIComponent(String(requestParameters['productIdentityKey'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GoogleMerchantProductMappingInputToJSON(requestParameters['googleMerchantProductMappingInput']),
        };
    }

    /**
     * Confirms an explicit Merchant product to ERP product identity mapping. Product titles are never accepted as identity.
     */
    async confirmGoogleMerchantProductMappingRaw(requestParameters: ConfirmGoogleMerchantProductMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleMerchantProductMappingData>> {
        const requestOptions = await this.confirmGoogleMerchantProductMappingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleMerchantProductMappingDataFromJSON(jsonValue));
    }

    /**
     * Confirms an explicit Merchant product to ERP product identity mapping. Product titles are never accepted as identity.
     */
    async confirmGoogleMerchantProductMapping(requestParameters: ConfirmGoogleMerchantProductMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleMerchantProductMappingData> {
        const response = await this.confirmGoogleMerchantProductMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createGoogleSearchConsoleBrandRuleRevision without sending the request
     */
    async createGoogleSearchConsoleBrandRuleRevisionRequestOpts(requestParameters: CreateGoogleSearchConsoleBrandRuleRevisionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling createGoogleSearchConsoleBrandRuleRevision().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling createGoogleSearchConsoleBrandRuleRevision().'
            );
        }

        if (requestParameters['googleSearchConsoleBrandRuleSetInput'] == null) {
            throw new runtime.RequiredError(
                'googleSearchConsoleBrandRuleSetInput',
                'Required parameter "googleSearchConsoleBrandRuleSetInput" was null or undefined when calling createGoogleSearchConsoleBrandRuleRevision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-search-console/{integrationId}/brand-rules`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GoogleSearchConsoleBrandRuleSetInputToJSON(requestParameters['googleSearchConsoleBrandRuleSetInput']),
        };
    }

    /**
     * Creates an immutable effective-dated literal brand classifier revision. It never rewrites source facts.
     */
    async createGoogleSearchConsoleBrandRuleRevisionRaw(requestParameters: CreateGoogleSearchConsoleBrandRuleRevisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleSearchConsoleBrandRuleSetData>> {
        const requestOptions = await this.createGoogleSearchConsoleBrandRuleRevisionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleSearchConsoleBrandRuleSetDataFromJSON(jsonValue));
    }

    /**
     * Creates an immutable effective-dated literal brand classifier revision. It never rewrites source facts.
     */
    async createGoogleSearchConsoleBrandRuleRevision(requestParameters: CreateGoogleSearchConsoleBrandRuleRevisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleSearchConsoleBrandRuleSetData> {
        const response = await this.createGoogleSearchConsoleBrandRuleRevisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteProjectIntegration without sending the request
     */
    async deleteProjectIntegrationRequestOpts(requestParameters: DeleteProjectIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deleteProjectIntegration().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling deleteProjectIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integration/{integrationId}`;
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes an integration from this platform.
     */
    async deleteProjectIntegrationRaw(requestParameters: DeleteProjectIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.deleteProjectIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Deletes an integration from this platform.
     */
    async deleteProjectIntegration(requestParameters: DeleteProjectIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteProjectIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for disconnectGoogleDataIntegration without sending the request
     */
    async disconnectGoogleDataIntegrationRequestOpts(requestParameters: DisconnectGoogleDataIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling disconnectGoogleDataIntegration().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling disconnectGoogleDataIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-data-integration/{integrationId}/disconnect`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Revokes the local grant of one integration without deleting resources or source history. Superadministrator only.
     */
    async disconnectGoogleDataIntegrationRaw(requestParameters: DisconnectGoogleDataIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.disconnectGoogleDataIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Revokes the local grant of one integration without deleting resources or source history. Superadministrator only.
     */
    async disconnectGoogleDataIntegration(requestParameters: DisconnectGoogleDataIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.disconnectGoogleDataIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for discoverGoogleAnalyticsProperties without sending the request
     */
    async discoverGoogleAnalyticsPropertiesRequestOpts(requestParameters: DiscoverGoogleAnalyticsPropertiesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling discoverGoogleAnalyticsProperties().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling discoverGoogleAnalyticsProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-analytics/{integrationId}/properties/discover`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Discovers accessible GA4 accounts/properties and their reporting timezone/currency. Superadministrator only.
     */
    async discoverGoogleAnalyticsPropertiesRaw(requestParameters: DiscoverGoogleAnalyticsPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoogleAnalyticsPropertyData>>> {
        const requestOptions = await this.discoverGoogleAnalyticsPropertiesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GoogleAnalyticsPropertyDataFromJSON));
    }

    /**
     * Discovers accessible GA4 accounts/properties and their reporting timezone/currency. Superadministrator only.
     */
    async discoverGoogleAnalyticsProperties(requestParameters: DiscoverGoogleAnalyticsPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoogleAnalyticsPropertyData>> {
        const response = await this.discoverGoogleAnalyticsPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for discoverGoogleBigQueryDatasets without sending the request
     */
    async discoverGoogleBigQueryDatasetsRequestOpts(requestParameters: DiscoverGoogleBigQueryDatasetsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling discoverGoogleBigQueryDatasets().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling discoverGoogleBigQueryDatasets().'
            );
        }

        if (requestParameters['dataProjectId'] == null) {
            throw new runtime.RequiredError(
                'dataProjectId',
                'Required parameter "dataProjectId" was null or undefined when calling discoverGoogleBigQueryDatasets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-bigquery/{integrationId}/projects/{dataProjectId}/datasets`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{dataProjectId}', encodeURIComponent(String(requestParameters['dataProjectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async discoverGoogleBigQueryDatasetsRaw(requestParameters: DiscoverGoogleBigQueryDatasetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoogleBigQueryResourceData>>> {
        const requestOptions = await this.discoverGoogleBigQueryDatasetsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GoogleBigQueryResourceDataFromJSON));
    }

    /**
     */
    async discoverGoogleBigQueryDatasets(requestParameters: DiscoverGoogleBigQueryDatasetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoogleBigQueryResourceData>> {
        const response = await this.discoverGoogleBigQueryDatasetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for discoverGoogleBigQueryProjects without sending the request
     */
    async discoverGoogleBigQueryProjectsRequestOpts(requestParameters: DiscoverGoogleBigQueryProjectsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling discoverGoogleBigQueryProjects().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling discoverGoogleBigQueryProjects().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-bigquery/{integrationId}/projects`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async discoverGoogleBigQueryProjectsRaw(requestParameters: DiscoverGoogleBigQueryProjectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoogleBigQueryResourceData>>> {
        const requestOptions = await this.discoverGoogleBigQueryProjectsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GoogleBigQueryResourceDataFromJSON));
    }

    /**
     */
    async discoverGoogleBigQueryProjects(requestParameters: DiscoverGoogleBigQueryProjectsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoogleBigQueryResourceData>> {
        const response = await this.discoverGoogleBigQueryProjectsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for discoverGoogleMerchantAccounts without sending the request
     */
    async discoverGoogleMerchantAccountsRequestOpts(requestParameters: DiscoverGoogleMerchantAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling discoverGoogleMerchantAccounts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling discoverGoogleMerchantAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-merchant/{integrationId}/accounts/discover`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async discoverGoogleMerchantAccountsRaw(requestParameters: DiscoverGoogleMerchantAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoogleMerchantAccountData>>> {
        const requestOptions = await this.discoverGoogleMerchantAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GoogleMerchantAccountDataFromJSON));
    }

    /**
     */
    async discoverGoogleMerchantAccounts(requestParameters: DiscoverGoogleMerchantAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoogleMerchantAccountData>> {
        const response = await this.discoverGoogleMerchantAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for discoverGoogleMerchantSubaccounts without sending the request
     */
    async discoverGoogleMerchantSubaccountsRequestOpts(requestParameters: DiscoverGoogleMerchantSubaccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling discoverGoogleMerchantSubaccounts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling discoverGoogleMerchantSubaccounts().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling discoverGoogleMerchantSubaccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-merchant/{integrationId}/accounts/{accountId}/subaccounts/discover`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{accountId}', encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async discoverGoogleMerchantSubaccountsRaw(requestParameters: DiscoverGoogleMerchantSubaccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoogleMerchantAccountData>>> {
        const requestOptions = await this.discoverGoogleMerchantSubaccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GoogleMerchantAccountDataFromJSON));
    }

    /**
     */
    async discoverGoogleMerchantSubaccounts(requestParameters: DiscoverGoogleMerchantSubaccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoogleMerchantAccountData>> {
        const response = await this.discoverGoogleMerchantSubaccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for discoverGoogleSearchConsoleSites without sending the request
     */
    async discoverGoogleSearchConsoleSitesRequestOpts(requestParameters: DiscoverGoogleSearchConsoleSitesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling discoverGoogleSearchConsoleSites().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling discoverGoogleSearchConsoleSites().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-search-console/{integrationId}/sites/discover`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Discovers Search Console domains accessible to the authorized Google account. Superadministrator only.
     */
    async discoverGoogleSearchConsoleSitesRaw(requestParameters: DiscoverGoogleSearchConsoleSitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoogleSearchConsoleSiteData>>> {
        const requestOptions = await this.discoverGoogleSearchConsoleSitesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GoogleSearchConsoleSiteDataFromJSON));
    }

    /**
     * Discovers Search Console domains accessible to the authorized Google account. Superadministrator only.
     */
    async discoverGoogleSearchConsoleSites(requestParameters: DiscoverGoogleSearchConsoleSitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoogleSearchConsoleSiteData>> {
        const response = await this.discoverGoogleSearchConsoleSitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getGoogleDataIntegrationUsage without sending the request
     */
    async getGoogleDataIntegrationUsageRequestOpts(requestParameters: GetGoogleDataIntegrationUsageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getGoogleDataIntegrationUsage().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling getGoogleDataIntegrationUsage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-data-integration/{integrationId}/usage`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns bounded daily usage totals and BigQuery budget state for one project integration.
     */
    async getGoogleDataIntegrationUsageRaw(requestParameters: GetGoogleDataIntegrationUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleIntegrationUsageData>> {
        const requestOptions = await this.getGoogleDataIntegrationUsageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleIntegrationUsageDataFromJSON(jsonValue));
    }

    /**
     * Returns bounded daily usage totals and BigQuery budget state for one project integration.
     */
    async getGoogleDataIntegrationUsage(requestParameters: GetGoogleDataIntegrationUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleIntegrationUsageData> {
        const response = await this.getGoogleDataIntegrationUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getGoogleMerchantMarketReportSettings without sending the request
     */
    async getGoogleMerchantMarketReportSettingsRequestOpts(requestParameters: GetGoogleMerchantMarketReportSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getGoogleMerchantMarketReportSettings().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling getGoogleMerchantMarketReportSettings().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getGoogleMerchantMarketReportSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-merchant/{integrationId}/accounts/{accountId}/market-report-settings`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{accountId}', encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getGoogleMerchantMarketReportSettingsRaw(requestParameters: GetGoogleMerchantMarketReportSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleMerchantAccountData>> {
        const requestOptions = await this.getGoogleMerchantMarketReportSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleMerchantAccountDataFromJSON(jsonValue));
    }

    /**
     */
    async getGoogleMerchantMarketReportSettings(requestParameters: GetGoogleMerchantMarketReportSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleMerchantAccountData> {
        const response = await this.getGoogleMerchantMarketReportSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for glamiIntegration without sending the request
     */
    async glamiIntegrationRequestOpts(requestParameters: GlamiIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling glamiIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/glami`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlamiIntegrationInputToJSON(requestParameters['glamiIntegrationInput']),
        };
    }

    /**
     * Create or update Glami integration.
     */
    async glamiIntegrationRaw(requestParameters: GlamiIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GlamiIntegrationData>> {
        const requestOptions = await this.glamiIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GlamiIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Glami integration.
     */
    async glamiIntegration(requestParameters: GlamiIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GlamiIntegrationData> {
        const response = await this.glamiIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleAnalyticsAggregateReport without sending the request
     */
    async googleAnalyticsAggregateReportRequestOpts(requestParameters: GoogleAnalyticsAggregateReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleAnalyticsAggregateReport().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleAnalyticsAggregateReport().'
            );
        }

        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling googleAnalyticsAggregateReport().'
            );
        }

        if (requestParameters['recipe'] == null) {
            throw new runtime.RequiredError(
                'recipe',
                'Required parameter "recipe" was null or undefined when calling googleAnalyticsAggregateReport().'
            );
        }

        if (requestParameters['since'] == null) {
            throw new runtime.RequiredError(
                'since',
                'Required parameter "since" was null or undefined when calling googleAnalyticsAggregateReport().'
            );
        }

        if (requestParameters['until'] == null) {
            throw new runtime.RequiredError(
                'until',
                'Required parameter "until" was null or undefined when calling googleAnalyticsAggregateReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['since'] != null) {
            queryParameters['since'] = (requestParameters['since'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-analytics/{integrationId}/properties/{propertyId}/reports/{recipe}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{propertyId}', encodeURIComponent(String(requestParameters['propertyId'])));
        urlPath = urlPath.replace('{recipe}', encodeURIComponent(String(requestParameters['recipe'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns one bounded, versioned GA4 aggregate report family. Daily active/new users are explicitly marked non-additive.
     */
    async googleAnalyticsAggregateReportRaw(requestParameters: GoogleAnalyticsAggregateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleAnalyticsAggregateReportData>> {
        const requestOptions = await this.googleAnalyticsAggregateReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleAnalyticsAggregateReportDataFromJSON(jsonValue));
    }

    /**
     * Returns one bounded, versioned GA4 aggregate report family. Daily active/new users are explicitly marked non-additive.
     */
    async googleAnalyticsAggregateReport(requestParameters: GoogleAnalyticsAggregateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleAnalyticsAggregateReportData> {
        const response = await this.googleAnalyticsAggregateReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleAnalyticsAttributionShadowPreview without sending the request
     */
    async googleAnalyticsAttributionShadowPreviewRequestOpts(requestParameters: GoogleAnalyticsAttributionShadowPreviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleAnalyticsAttributionShadowPreview().'
            );
        }

        if (requestParameters['since'] == null) {
            throw new runtime.RequiredError(
                'since',
                'Required parameter "since" was null or undefined when calling googleAnalyticsAttributionShadowPreview().'
            );
        }

        if (requestParameters['until'] == null) {
            throw new runtime.RequiredError(
                'until',
                'Required parameter "until" was null or undefined when calling googleAnalyticsAttributionShadowPreview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['since'] != null) {
            queryParameters['since'] = (requestParameters['since'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-analytics/attribution-shadow`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Read-only exact transaction-ID reconciliation. It never writes attribution or hydrates provider entities.
     */
    async googleAnalyticsAttributionShadowPreviewRaw(requestParameters: GoogleAnalyticsAttributionShadowPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleAnalyticsAttributionShadowPreviewData>> {
        const requestOptions = await this.googleAnalyticsAttributionShadowPreviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleAnalyticsAttributionShadowPreviewDataFromJSON(jsonValue));
    }

    /**
     * Read-only exact transaction-ID reconciliation. It never writes attribution or hydrates provider entities.
     */
    async googleAnalyticsAttributionShadowPreview(requestParameters: GoogleAnalyticsAttributionShadowPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleAnalyticsAttributionShadowPreviewData> {
        const response = await this.googleAnalyticsAttributionShadowPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleBigQueryGA4ExportReport without sending the request
     */
    async googleBigQueryGA4ExportReportRequestOpts(requestParameters: GoogleBigQueryGA4ExportReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleBigQueryGA4ExportReport().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleBigQueryGA4ExportReport().'
            );
        }

        if (requestParameters['recipeId'] == null) {
            throw new runtime.RequiredError(
                'recipeId',
                'Required parameter "recipeId" was null or undefined when calling googleBigQueryGA4ExportReport().'
            );
        }

        if (requestParameters['since'] == null) {
            throw new runtime.RequiredError(
                'since',
                'Required parameter "since" was null or undefined when calling googleBigQueryGA4ExportReport().'
            );
        }

        if (requestParameters['until'] == null) {
            throw new runtime.RequiredError(
                'until',
                'Required parameter "until" was null or undefined when calling googleBigQueryGA4ExportReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['since'] != null) {
            queryParameters['since'] = (requestParameters['since'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-bigquery/{integrationId}/recipes/{recipeId}/ga4-export-report`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{recipeId}', encodeURIComponent(String(requestParameters['recipeId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns bounded event, session, transaction, landing-page and acquisition details from the selected GA4 export recipe. These facts are detail enrichment and measurement evidence by default.
     */
    async googleBigQueryGA4ExportReportRaw(requestParameters: GoogleBigQueryGA4ExportReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleBigQueryGa4ReportData>> {
        const requestOptions = await this.googleBigQueryGA4ExportReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleBigQueryGa4ReportDataFromJSON(jsonValue));
    }

    /**
     * Returns bounded event, session, transaction, landing-page and acquisition details from the selected GA4 export recipe. These facts are detail enrichment and measurement evidence by default.
     */
    async googleBigQueryGA4ExportReport(requestParameters: GoogleBigQueryGA4ExportReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleBigQueryGa4ReportData> {
        const response = await this.googleBigQueryGA4ExportReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleBigQueryGA4PseudonymousUsersReport without sending the request
     */
    async googleBigQueryGA4PseudonymousUsersReportRequestOpts(requestParameters: GoogleBigQueryGA4PseudonymousUsersReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleBigQueryGA4PseudonymousUsersReport().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleBigQueryGA4PseudonymousUsersReport().'
            );
        }

        if (requestParameters['since'] == null) {
            throw new runtime.RequiredError(
                'since',
                'Required parameter "since" was null or undefined when calling googleBigQueryGA4PseudonymousUsersReport().'
            );
        }

        if (requestParameters['until'] == null) {
            throw new runtime.RequiredError(
                'until',
                'Required parameter "until" was null or undefined when calling googleBigQueryGA4PseudonymousUsersReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['since'] != null) {
            queryParameters['since'] = (requestParameters['since'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-bigquery/{integrationId}/ga4-pseudonymous-users-report`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns aggregate-only counts from completed GA4 pseudonymous-users daily publications. Counts describe observed pseudonymous identifiers or identifier-days, not people, customers or cross-device users.
     */
    async googleBigQueryGA4PseudonymousUsersReportRaw(requestParameters: GoogleBigQueryGA4PseudonymousUsersReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleBigQueryGa4PseudonymousUsersReportData>> {
        const requestOptions = await this.googleBigQueryGA4PseudonymousUsersReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleBigQueryGa4PseudonymousUsersReportDataFromJSON(jsonValue));
    }

    /**
     * Returns aggregate-only counts from completed GA4 pseudonymous-users daily publications. Counts describe observed pseudonymous identifiers or identifier-days, not people, customers or cross-device users.
     */
    async googleBigQueryGA4PseudonymousUsersReport(requestParameters: GoogleBigQueryGA4PseudonymousUsersReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleBigQueryGa4PseudonymousUsersReportData> {
        const response = await this.googleBigQueryGA4PseudonymousUsersReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleDataCrossSystemReport without sending the request
     */
    async googleDataCrossSystemReportRequestOpts(requestParameters: GoogleDataCrossSystemReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleDataCrossSystemReport().'
            );
        }

        if (requestParameters['since'] == null) {
            throw new runtime.RequiredError(
                'since',
                'Required parameter "since" was null or undefined when calling googleDataCrossSystemReport().'
            );
        }

        if (requestParameters['until'] == null) {
            throw new runtime.RequiredError(
                'until',
                'Required parameter "until" was null or undefined when calling googleDataCrossSystemReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['since'] != null) {
            queryParameters['since'] = (requestParameters['since'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-data/cross-system-report`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Daily additive primitives for paid, organic, GA4 measurement, first-party events and ERP commerce. Measurement revenue remains distinct from ERP turnover.
     */
    async googleDataCrossSystemReportRaw(requestParameters: GoogleDataCrossSystemReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleCrossSystemReportData>> {
        const requestOptions = await this.googleDataCrossSystemReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleCrossSystemReportDataFromJSON(jsonValue));
    }

    /**
     * Daily additive primitives for paid, organic, GA4 measurement, first-party events and ERP commerce. Measurement revenue remains distinct from ERP turnover.
     */
    async googleDataCrossSystemReport(requestParameters: GoogleDataCrossSystemReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleCrossSystemReportData> {
        const response = await this.googleDataCrossSystemReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleDataSourceOwnershipDiagnostics without sending the request
     */
    async googleDataSourceOwnershipDiagnosticsRequestOpts(requestParameters: GoogleDataSourceOwnershipDiagnosticsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleDataSourceOwnershipDiagnostics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-data/source-ownership`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async googleDataSourceOwnershipDiagnosticsRaw(requestParameters: GoogleDataSourceOwnershipDiagnosticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleFactOwnershipDiagnosticsData>> {
        const requestOptions = await this.googleDataSourceOwnershipDiagnosticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleFactOwnershipDiagnosticsDataFromJSON(jsonValue));
    }

    /**
     */
    async googleDataSourceOwnershipDiagnostics(requestParameters: GoogleDataSourceOwnershipDiagnosticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleFactOwnershipDiagnosticsData> {
        const response = await this.googleDataSourceOwnershipDiagnosticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleLandingPageFunnel without sending the request
     */
    async googleLandingPageFunnelRequestOpts(requestParameters: GoogleLandingPageFunnelRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleLandingPageFunnel().'
            );
        }

        if (requestParameters['searchConsoleIntegrationId'] == null) {
            throw new runtime.RequiredError(
                'searchConsoleIntegrationId',
                'Required parameter "searchConsoleIntegrationId" was null or undefined when calling googleLandingPageFunnel().'
            );
        }

        if (requestParameters['searchConsoleSiteId'] == null) {
            throw new runtime.RequiredError(
                'searchConsoleSiteId',
                'Required parameter "searchConsoleSiteId" was null or undefined when calling googleLandingPageFunnel().'
            );
        }

        if (requestParameters['analyticsIntegrationId'] == null) {
            throw new runtime.RequiredError(
                'analyticsIntegrationId',
                'Required parameter "analyticsIntegrationId" was null or undefined when calling googleLandingPageFunnel().'
            );
        }

        if (requestParameters['analyticsPropertyId'] == null) {
            throw new runtime.RequiredError(
                'analyticsPropertyId',
                'Required parameter "analyticsPropertyId" was null or undefined when calling googleLandingPageFunnel().'
            );
        }

        if (requestParameters['since'] == null) {
            throw new runtime.RequiredError(
                'since',
                'Required parameter "since" was null or undefined when calling googleLandingPageFunnel().'
            );
        }

        if (requestParameters['until'] == null) {
            throw new runtime.RequiredError(
                'until',
                'Required parameter "until" was null or undefined when calling googleLandingPageFunnel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchConsoleIntegrationId'] != null) {
            queryParameters['searchConsoleIntegrationId'] = requestParameters['searchConsoleIntegrationId'];
        }

        if (requestParameters['searchConsoleSiteId'] != null) {
            queryParameters['searchConsoleSiteId'] = requestParameters['searchConsoleSiteId'];
        }

        if (requestParameters['analyticsIntegrationId'] != null) {
            queryParameters['analyticsIntegrationId'] = requestParameters['analyticsIntegrationId'];
        }

        if (requestParameters['analyticsPropertyId'] != null) {
            queryParameters['analyticsPropertyId'] = requestParameters['analyticsPropertyId'];
        }

        if (requestParameters['since'] != null) {
            queryParameters['since'] = (requestParameters['since'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-data/landing-page-funnel`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Joins Search Console and GA4 measurement on a normalized landing-page key. ERP commerce is returned separately at its truthful domain grain and is never attributed to an individual query or page.
     */
    async googleLandingPageFunnelRaw(requestParameters: GoogleLandingPageFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleLandingPageFunnelData>> {
        const requestOptions = await this.googleLandingPageFunnelRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleLandingPageFunnelDataFromJSON(jsonValue));
    }

    /**
     * Joins Search Console and GA4 measurement on a normalized landing-page key. ERP commerce is returned separately at its truthful domain grain and is never attributed to an individual query or page.
     */
    async googleLandingPageFunnel(requestParameters: GoogleLandingPageFunnelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleLandingPageFunnelData> {
        const response = await this.googleLandingPageFunnelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleMerchantCatalogueHealth without sending the request
     */
    async googleMerchantCatalogueHealthRequestOpts(requestParameters: GoogleMerchantCatalogueHealthRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleMerchantCatalogueHealth().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleMerchantCatalogueHealth().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling googleMerchantCatalogueHealth().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-merchant/{integrationId}/accounts/{accountId}/catalogue-health`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{accountId}', encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns catalogue approval, mapping, inventory, traffic, completeness and freshness for one selected Merchant account.
     */
    async googleMerchantCatalogueHealthRaw(requestParameters: GoogleMerchantCatalogueHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleMerchantCatalogHealthData>> {
        const requestOptions = await this.googleMerchantCatalogueHealthRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleMerchantCatalogHealthDataFromJSON(jsonValue));
    }

    /**
     * Returns catalogue approval, mapping, inventory, traffic, completeness and freshness for one selected Merchant account.
     */
    async googleMerchantCatalogueHealth(requestParameters: GoogleMerchantCatalogueHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleMerchantCatalogHealthData> {
        const response = await this.googleMerchantCatalogueHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleMerchantCatalogueProducts without sending the request
     */
    async googleMerchantCatalogueProductsRequestOpts(requestParameters: GoogleMerchantCatalogueProductsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleMerchantCatalogueProducts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleMerchantCatalogueProducts().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling googleMerchantCatalogueProducts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-merchant/{integrationId}/accounts/{accountId}/products`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{accountId}', encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns one bounded server-side page from the currently published Merchant catalogue.
     */
    async googleMerchantCatalogueProductsRaw(requestParameters: GoogleMerchantCatalogueProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleMerchantCatalogProductPageData>> {
        const requestOptions = await this.googleMerchantCatalogueProductsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleMerchantCatalogProductPageDataFromJSON(jsonValue));
    }

    /**
     * Returns one bounded server-side page from the currently published Merchant catalogue.
     */
    async googleMerchantCatalogueProducts(requestParameters: GoogleMerchantCatalogueProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleMerchantCatalogProductPageData> {
        const response = await this.googleMerchantCatalogueProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleMerchantMarketReports without sending the request
     */
    async googleMerchantMarketReportsRequestOpts(requestParameters: GoogleMerchantMarketReportsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleMerchantMarketReports().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleMerchantMarketReports().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling googleMerchantMarketReports().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-merchant/{integrationId}/accounts/{accountId}/market-reports`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{accountId}', encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Current bounded best-seller and competitive-visibility publications. Missing or ineligible recipes remain unavailable, not zero.
     */
    async googleMerchantMarketReportsRaw(requestParameters: GoogleMerchantMarketReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleMerchantMarketReportData>> {
        const requestOptions = await this.googleMerchantMarketReportsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleMerchantMarketReportDataFromJSON(jsonValue));
    }

    /**
     * Current bounded best-seller and competitive-visibility publications. Missing or ineligible recipes remain unavailable, not zero.
     */
    async googleMerchantMarketReports(requestParameters: GoogleMerchantMarketReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleMerchantMarketReportData> {
        const response = await this.googleMerchantMarketReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleMerchantPriceReports without sending the request
     */
    async googleMerchantPriceReportsRequestOpts(requestParameters: GoogleMerchantPriceReportsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleMerchantPriceReports().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleMerchantPriceReports().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling googleMerchantPriceReports().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-merchant/{integrationId}/accounts/{accountId}/price-reports`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{accountId}', encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Current price competitiveness and price insight publications. Missing or ineligible reports remain unavailable, not zero.
     */
    async googleMerchantPriceReportsRaw(requestParameters: GoogleMerchantPriceReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleMerchantPriceReportData>> {
        const requestOptions = await this.googleMerchantPriceReportsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleMerchantPriceReportDataFromJSON(jsonValue));
    }

    /**
     * Current price competitiveness and price insight publications. Missing or ineligible reports remain unavailable, not zero.
     */
    async googleMerchantPriceReports(requestParameters: GoogleMerchantPriceReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleMerchantPriceReportData> {
        const response = await this.googleMerchantPriceReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleSearchConsoleBrandReport without sending the request
     */
    async googleSearchConsoleBrandReportRequestOpts(requestParameters: GoogleSearchConsoleBrandReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleSearchConsoleBrandReport().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleSearchConsoleBrandReport().'
            );
        }

        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling googleSearchConsoleBrandReport().'
            );
        }

        if (requestParameters['since'] == null) {
            throw new runtime.RequiredError(
                'since',
                'Required parameter "since" was null or undefined when calling googleSearchConsoleBrandReport().'
            );
        }

        if (requestParameters['until'] == null) {
            throw new runtime.RequiredError(
                'until',
                'Required parameter "until" was null or undefined when calling googleSearchConsoleBrandReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['since'] != null) {
            queryParameters['since'] = (requestParameters['since'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-search-console/{integrationId}/sites/{siteId}/brand-report`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{siteId}', encodeURIComponent(String(requestParameters['siteId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Classifies provider-limited query facts using the effective rule revision for each fact date.
     */
    async googleSearchConsoleBrandReportRaw(requestParameters: GoogleSearchConsoleBrandReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleSearchConsoleBrandReportData>> {
        const requestOptions = await this.googleSearchConsoleBrandReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleSearchConsoleBrandReportDataFromJSON(jsonValue));
    }

    /**
     * Classifies provider-limited query facts using the effective rule revision for each fact date.
     */
    async googleSearchConsoleBrandReport(requestParameters: GoogleSearchConsoleBrandReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleSearchConsoleBrandReportData> {
        const response = await this.googleSearchConsoleBrandReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleSearchConsoleBrandRules without sending the request
     */
    async googleSearchConsoleBrandRulesRequestOpts(requestParameters: GoogleSearchConsoleBrandRulesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleSearchConsoleBrandRules().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleSearchConsoleBrandRules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-search-console/{integrationId}/brand-rules`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns immutable effective-dated literal brand rule revisions.
     */
    async googleSearchConsoleBrandRulesRaw(requestParameters: GoogleSearchConsoleBrandRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoogleSearchConsoleBrandRuleSetData>>> {
        const requestOptions = await this.googleSearchConsoleBrandRulesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GoogleSearchConsoleBrandRuleSetDataFromJSON));
    }

    /**
     * Returns immutable effective-dated literal brand rule revisions.
     */
    async googleSearchConsoleBrandRules(requestParameters: GoogleSearchConsoleBrandRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoogleSearchConsoleBrandRuleSetData>> {
        const response = await this.googleSearchConsoleBrandRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleSearchConsoleCannibalizationReport without sending the request
     */
    async googleSearchConsoleCannibalizationReportRequestOpts(requestParameters: GoogleSearchConsoleCannibalizationReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleSearchConsoleCannibalizationReport().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleSearchConsoleCannibalizationReport().'
            );
        }

        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling googleSearchConsoleCannibalizationReport().'
            );
        }

        if (requestParameters['since'] == null) {
            throw new runtime.RequiredError(
                'since',
                'Required parameter "since" was null or undefined when calling googleSearchConsoleCannibalizationReport().'
            );
        }

        if (requestParameters['until'] == null) {
            throw new runtime.RequiredError(
                'until',
                'Required parameter "until" was null or undefined when calling googleSearchConsoleCannibalizationReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['since'] != null) {
            queryParameters['since'] = (requestParameters['since'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-search-console/{integrationId}/sites/{siteId}/cannibalization`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{siteId}', encodeURIComponent(String(requestParameters['siteId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a bounded server-aggregated page of queries that appeared with more than one landing page. Provider detail can be partial.
     */
    async googleSearchConsoleCannibalizationReportRaw(requestParameters: GoogleSearchConsoleCannibalizationReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleSearchConsoleCannibalizationPageData>> {
        const requestOptions = await this.googleSearchConsoleCannibalizationReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleSearchConsoleCannibalizationPageDataFromJSON(jsonValue));
    }

    /**
     * Returns a bounded server-aggregated page of queries that appeared with more than one landing page. Provider detail can be partial.
     */
    async googleSearchConsoleCannibalizationReport(requestParameters: GoogleSearchConsoleCannibalizationReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleSearchConsoleCannibalizationPageData> {
        const response = await this.googleSearchConsoleCannibalizationReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleSearchConsoleReport without sending the request
     */
    async googleSearchConsoleReportRequestOpts(requestParameters: GoogleSearchConsoleReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleSearchConsoleReport().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleSearchConsoleReport().'
            );
        }

        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling googleSearchConsoleReport().'
            );
        }

        if (requestParameters['recipe'] == null) {
            throw new runtime.RequiredError(
                'recipe',
                'Required parameter "recipe" was null or undefined when calling googleSearchConsoleReport().'
            );
        }

        if (requestParameters['since'] == null) {
            throw new runtime.RequiredError(
                'since',
                'Required parameter "since" was null or undefined when calling googleSearchConsoleReport().'
            );
        }

        if (requestParameters['until'] == null) {
            throw new runtime.RequiredError(
                'until',
                'Required parameter "until" was null or undefined when calling googleSearchConsoleReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['since'] != null) {
            queryParameters['since'] = (requestParameters['since'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = (requestParameters['until'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-search-console/{integrationId}/sites/{siteId}/reports/{recipe}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{siteId}', encodeURIComponent(String(requestParameters['siteId'])));
        urlPath = urlPath.replace('{recipe}', encodeURIComponent(String(requestParameters['recipe'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns one bounded current Search Console publication. Detail rows can be partial/truncated and CTR/position are non-additive.
     */
    async googleSearchConsoleReportRaw(requestParameters: GoogleSearchConsoleReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleSearchConsoleReportData>> {
        const requestOptions = await this.googleSearchConsoleReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleSearchConsoleReportDataFromJSON(jsonValue));
    }

    /**
     * Returns one bounded current Search Console publication. Detail rows can be partial/truncated and CTR/position are non-additive.
     */
    async googleSearchConsoleReport(requestParameters: GoogleSearchConsoleReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleSearchConsoleReportData> {
        const response = await this.googleSearchConsoleReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleSearchConsoleURLInspections without sending the request
     */
    async googleSearchConsoleURLInspectionsRequestOpts(requestParameters: GoogleSearchConsoleURLInspectionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling googleSearchConsoleURLInspections().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling googleSearchConsoleURLInspections().'
            );
        }

        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling googleSearchConsoleURLInspections().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-search-console/{integrationId}/sites/{siteId}/url-inspections`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{siteId}', encodeURIComponent(String(requestParameters['siteId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the latest persisted point-in-time URL Inspection evidence for at most 100 URLs. This is not a complete index coverage dataset.
     */
    async googleSearchConsoleURLInspectionsRaw(requestParameters: GoogleSearchConsoleURLInspectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GoogleSearchConsoleUrlInspectionRowData>>> {
        const requestOptions = await this.googleSearchConsoleURLInspectionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GoogleSearchConsoleUrlInspectionRowDataFromJSON));
    }

    /**
     * Returns the latest persisted point-in-time URL Inspection evidence for at most 100 URLs. This is not a complete index coverage dataset.
     */
    async googleSearchConsoleURLInspections(requestParameters: GoogleSearchConsoleURLInspectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GoogleSearchConsoleUrlInspectionRowData>> {
        const response = await this.googleSearchConsoleURLInspectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for heurekaIntegration without sending the request
     */
    async heurekaIntegrationRequestOpts(requestParameters: HeurekaIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling heurekaIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/heureka`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HeurekaIntegrationInputToJSON(requestParameters['heurekaIntegrationInput']),
        };
    }

    /**
     * Create or update Heureka integration.
     */
    async heurekaIntegrationRaw(requestParameters: HeurekaIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HeurekaIntegrationData>> {
        const requestOptions = await this.heurekaIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HeurekaIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Heureka integration.
     */
    async heurekaIntegration(requestParameters: HeurekaIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HeurekaIntegrationData> {
        const response = await this.heurekaIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for inspectGoogleSearchConsoleURLs without sending the request
     */
    async inspectGoogleSearchConsoleURLsRequestOpts(requestParameters: InspectGoogleSearchConsoleURLsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling inspectGoogleSearchConsoleURLs().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling inspectGoogleSearchConsoleURLs().'
            );
        }

        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling inspectGoogleSearchConsoleURLs().'
            );
        }

        if (requestParameters['googleSearchConsoleUrlInspectionInput'] == null) {
            throw new runtime.RequiredError(
                'googleSearchConsoleUrlInspectionInput',
                'Required parameter "googleSearchConsoleUrlInspectionInput" was null or undefined when calling inspectGoogleSearchConsoleURLs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-search-console/{integrationId}/sites/{siteId}/url-inspections`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{siteId}', encodeURIComponent(String(requestParameters['siteId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GoogleSearchConsoleUrlInspectionInputToJSON(requestParameters['googleSearchConsoleUrlInspectionInput']),
        };
    }

    /**
     * Explicitly inspects between 1 and 20 URLs inside the selected verified Search Console site and persists successful point-in-time evidence. This provider read consumes URL Inspection quota.
     */
    async inspectGoogleSearchConsoleURLsRaw(requestParameters: InspectGoogleSearchConsoleURLsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleSearchConsoleUrlInspectionBatchData>> {
        const requestOptions = await this.inspectGoogleSearchConsoleURLsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleSearchConsoleUrlInspectionBatchDataFromJSON(jsonValue));
    }

    /**
     * Explicitly inspects between 1 and 20 URLs inside the selected verified Search Console site and persists successful point-in-time evidence. This provider read consumes URL Inspection quota.
     */
    async inspectGoogleSearchConsoleURLs(requestParameters: InspectGoogleSearchConsoleURLsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleSearchConsoleUrlInspectionBatchData> {
        const response = await this.inspectGoogleSearchConsoleURLsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for installGoogleDataIntegration without sending the request
     */
    async installGoogleDataIntegrationRequestOpts(requestParameters: InstallGoogleDataIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling installGoogleDataIntegration().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling installGoogleDataIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-data-integration/{type}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{type}', encodeURIComponent(String(requestParameters['type'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Starts installation OAuth. The independent integration is created only after a successful code exchange. Superadministrator only.
     */
    async installGoogleDataIntegrationRaw(requestParameters: InstallGoogleDataIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleOAuthAuthorizationData>> {
        const requestOptions = await this.installGoogleDataIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleOAuthAuthorizationDataFromJSON(jsonValue));
    }

    /**
     * Starts installation OAuth. The independent integration is created only after a successful code exchange. Superadministrator only.
     */
    async installGoogleDataIntegration(requestParameters: InstallGoogleDataIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleOAuthAuthorizationData> {
        const response = await this.installGoogleDataIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listProjectIntegrations without sending the request
     */
    async listProjectIntegrationsRequestOpts(requestParameters: ListProjectIntegrationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling listProjectIntegrations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integrations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns list of integration by project id.
     */
    async listProjectIntegrationsRaw(requestParameters: ListProjectIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListProjectIntegrations200ResponseInner>>> {
        const requestOptions = await this.listProjectIntegrationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListProjectIntegrations200ResponseInnerFromJSON));
    }

    /**
     * Returns list of integration by project id.
     */
    async listProjectIntegrations(requestParameters: ListProjectIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListProjectIntegrations200ResponseInner>> {
        const response = await this.listProjectIntegrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mySQLLeadIntegration without sending the request
     */
    async mySQLLeadIntegrationRequestOpts(requestParameters: MySQLLeadIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling mySQLLeadIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/mysql-lead`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MySQLLeadIntegrationInputToJSON(requestParameters['mySQLLeadIntegrationInput']),
        };
    }

    /**
     * Create or update MySQL Lead integration.
     */
    async mySQLLeadIntegrationRaw(requestParameters: MySQLLeadIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MySQLLeadIntegrationData>> {
        const requestOptions = await this.mySQLLeadIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MySQLLeadIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update MySQL Lead integration.
     */
    async mySQLLeadIntegration(requestParameters: MySQLLeadIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MySQLLeadIntegrationData> {
        const response = await this.mySQLLeadIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for pauseProjectIntegration without sending the request
     */
    async pauseProjectIntegrationRequestOpts(requestParameters: PauseProjectIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling pauseProjectIntegration().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling pauseProjectIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integration/{integrationId}/pause`;
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Pauses scheduler execution while preserving authorization, configuration and published history.
     */
    async pauseProjectIntegrationRaw(requestParameters: PauseProjectIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.pauseProjectIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Pauses scheduler execution while preserving authorization, configuration and published history.
     */
    async pauseProjectIntegration(requestParameters: PauseProjectIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.pauseProjectIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for previewGoogleSearchConsoleBrandReport without sending the request
     */
    async previewGoogleSearchConsoleBrandReportRequestOpts(requestParameters: PreviewGoogleSearchConsoleBrandReportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling previewGoogleSearchConsoleBrandReport().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling previewGoogleSearchConsoleBrandReport().'
            );
        }

        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling previewGoogleSearchConsoleBrandReport().'
            );
        }

        if (requestParameters['googleSearchConsoleBrandPreviewInput'] == null) {
            throw new runtime.RequiredError(
                'googleSearchConsoleBrandPreviewInput',
                'Required parameter "googleSearchConsoleBrandPreviewInput" was null or undefined when calling previewGoogleSearchConsoleBrandReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-search-console/{integrationId}/sites/{siteId}/brand-report/preview`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{siteId}', encodeURIComponent(String(requestParameters['siteId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GoogleSearchConsoleBrandPreviewInputToJSON(requestParameters['googleSearchConsoleBrandPreviewInput']),
        };
    }

    /**
     * Read-only preview of proposed literal terms; nothing is persisted.
     */
    async previewGoogleSearchConsoleBrandReportRaw(requestParameters: PreviewGoogleSearchConsoleBrandReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleSearchConsoleBrandReportData>> {
        const requestOptions = await this.previewGoogleSearchConsoleBrandReportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleSearchConsoleBrandReportDataFromJSON(jsonValue));
    }

    /**
     * Read-only preview of proposed literal terms; nothing is persisted.
     */
    async previewGoogleSearchConsoleBrandReport(requestParameters: PreviewGoogleSearchConsoleBrandReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleSearchConsoleBrandReportData> {
        const response = await this.previewGoogleSearchConsoleBrandReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for refreshProjectOAuthIntegrationResources without sending the request
     */
    async refreshProjectOAuthIntegrationResourcesRequestOpts(requestParameters: RefreshProjectOAuthIntegrationResourcesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling refreshProjectOAuthIntegrationResources().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling refreshProjectOAuthIntegrationResources().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integration/{integrationId}/refresh-resources`;
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Refreshes provider resources; integrations with availability synchronization may remove selected resources no longer enabled by the provider.
     */
    async refreshProjectOAuthIntegrationResourcesRaw(requestParameters: RefreshProjectOAuthIntegrationResourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.refreshProjectOAuthIntegrationResourcesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Refreshes provider resources; integrations with availability synchronization may remove selected resources no longer enabled by the provider.
     */
    async refreshProjectOAuthIntegrationResources(requestParameters: RefreshProjectOAuthIntegrationResourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.refreshProjectOAuthIntegrationResourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resumeProjectIntegration without sending the request
     */
    async resumeProjectIntegrationRequestOpts(requestParameters: ResumeProjectIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling resumeProjectIntegration().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling resumeProjectIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/integration/{integrationId}/resume`;
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Resumes scheduler execution without changing authorization or selected resources.
     */
    async resumeProjectIntegrationRaw(requestParameters: ResumeProjectIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.resumeProjectIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Resumes scheduler execution without changing authorization or selected resources.
     */
    async resumeProjectIntegration(requestParameters: ResumeProjectIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.resumeProjectIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rollbackGoogleAnalyticsAttributionFallback without sending the request
     */
    async rollbackGoogleAnalyticsAttributionFallbackRequestOpts(requestParameters: RollbackGoogleAnalyticsAttributionFallbackRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling rollbackGoogleAnalyticsAttributionFallback().'
            );
        }

        if (requestParameters['revisionId'] == null) {
            throw new runtime.RequiredError(
                'revisionId',
                'Required parameter "revisionId" was null or undefined when calling rollbackGoogleAnalyticsAttributionFallback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-analytics/attribution-fallback/{revisionId}/rollback`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{revisionId}', encodeURIComponent(String(requestParameters['revisionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Restores the exact pre-mutation attribution snapshot. It fails closed if the order attribution changed after the revision.
     */
    async rollbackGoogleAnalyticsAttributionFallbackRaw(requestParameters: RollbackGoogleAnalyticsAttributionFallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleAnalyticsAttributionMutationData>> {
        const requestOptions = await this.rollbackGoogleAnalyticsAttributionFallbackRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleAnalyticsAttributionMutationDataFromJSON(jsonValue));
    }

    /**
     * Restores the exact pre-mutation attribution snapshot. It fails closed if the order attribution changed after the revision.
     */
    async rollbackGoogleAnalyticsAttributionFallback(requestParameters: RollbackGoogleAnalyticsAttributionFallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleAnalyticsAttributionMutationData> {
        const response = await this.rollbackGoogleAnalyticsAttributionFallbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rollbackGoogleDataSourceOwnership without sending the request
     */
    async rollbackGoogleDataSourceOwnershipRequestOpts(requestParameters: RollbackGoogleDataSourceOwnershipRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling rollbackGoogleDataSourceOwnership().'
            );
        }

        if (requestParameters['transitionId'] == null) {
            throw new runtime.RequiredError(
                'transitionId',
                'Required parameter "transitionId" was null or undefined when calling rollbackGoogleDataSourceOwnership().'
            );
        }

        if (requestParameters['effectiveFrom'] == null) {
            throw new runtime.RequiredError(
                'effectiveFrom',
                'Required parameter "effectiveFrom" was null or undefined when calling rollbackGoogleDataSourceOwnership().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['effectiveFrom'] != null) {
            queryParameters['effectiveFrom'] = (requestParameters['effectiveFrom'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-data/source-ownership/transitions/{transitionId}/rollback`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{transitionId}', encodeURIComponent(String(requestParameters['transitionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Creates an effective-dated return to the previous primary without deleting authorization or history.
     */
    async rollbackGoogleDataSourceOwnershipRaw(requestParameters: RollbackGoogleDataSourceOwnershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleFactOwnershipTransitionData>> {
        const requestOptions = await this.rollbackGoogleDataSourceOwnershipRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleFactOwnershipTransitionDataFromJSON(jsonValue));
    }

    /**
     * Creates an effective-dated return to the previous primary without deleting authorization or history.
     */
    async rollbackGoogleDataSourceOwnership(requestParameters: RollbackGoogleDataSourceOwnershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleFactOwnershipTransitionData> {
        const response = await this.rollbackGoogleDataSourceOwnershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for selectGoogleAnalyticsProperties without sending the request
     */
    async selectGoogleAnalyticsPropertiesRequestOpts(requestParameters: SelectGoogleAnalyticsPropertiesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling selectGoogleAnalyticsProperties().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling selectGoogleAnalyticsProperties().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling selectGoogleAnalyticsProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-analytics/{integrationId}/properties`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Selects any combination of properties previously discovered by this integration. Superadministrator only.
     */
    async selectGoogleAnalyticsPropertiesRaw(requestParameters: SelectGoogleAnalyticsPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.selectGoogleAnalyticsPropertiesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Selects any combination of properties previously discovered by this integration. Superadministrator only.
     */
    async selectGoogleAnalyticsProperties(requestParameters: SelectGoogleAnalyticsPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.selectGoogleAnalyticsPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for selectGoogleMerchantAccounts without sending the request
     */
    async selectGoogleMerchantAccountsRequestOpts(requestParameters: SelectGoogleMerchantAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling selectGoogleMerchantAccounts().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling selectGoogleMerchantAccounts().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling selectGoogleMerchantAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-merchant/{integrationId}/accounts`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async selectGoogleMerchantAccountsRaw(requestParameters: SelectGoogleMerchantAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.selectGoogleMerchantAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async selectGoogleMerchantAccounts(requestParameters: SelectGoogleMerchantAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.selectGoogleMerchantAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for selectGoogleSearchConsoleSites without sending the request
     */
    async selectGoogleSearchConsoleSitesRequestOpts(requestParameters: SelectGoogleSearchConsoleSitesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling selectGoogleSearchConsoleSites().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling selectGoogleSearchConsoleSites().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling selectGoogleSearchConsoleSites().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-search-console/{integrationId}/sites`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Selects discovered Search Console domains. Missing project domains are created and enabled within the subscription limit. Superadministrator only.
     */
    async selectGoogleSearchConsoleSitesRaw(requestParameters: SelectGoogleSearchConsoleSitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.selectGoogleSearchConsoleSitesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Selects discovered Search Console domains. Missing project domains are created and enabled within the subscription limit. Superadministrator only.
     */
    async selectGoogleSearchConsoleSites(requestParameters: SelectGoogleSearchConsoleSitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.selectGoogleSearchConsoleSitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shoptetIntegration without sending the request
     */
    async shoptetIntegrationRequestOpts(requestParameters: ShoptetIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shoptetIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/shoptet`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShoptetIntegrationInputToJSON(requestParameters['shoptetIntegrationInput']),
        };
    }

    /**
     * Create or update Shoptet integration.
     */
    async shoptetIntegrationRaw(requestParameters: ShoptetIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShoptetIntegrationData>> {
        const requestOptions = await this.shoptetIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShoptetIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Shoptet integration.
     */
    async shoptetIntegration(requestParameters: ShoptetIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShoptetIntegrationData> {
        const response = await this.shoptetIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sklikIntegration without sending the request
     */
    async sklikIntegrationRequestOpts(requestParameters: SklikIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling sklikIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/sklik`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SklikIntegrationInputToJSON(requestParameters['sklikIntegrationInput']),
        };
    }

    /**
     * Create or update Sklik integration.
     */
    async sklikIntegrationRaw(requestParameters: SklikIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SklikIntegrationData>> {
        const requestOptions = await this.sklikIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SklikIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Sklik integration.
     */
    async sklikIntegration(requestParameters: SklikIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SklikIntegrationData> {
        const response = await this.sklikIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startGoogleDataIntegrationOAuth without sending the request
     */
    async startGoogleDataIntegrationOAuthRequestOpts(requestParameters: StartGoogleDataIntegrationOAuthRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling startGoogleDataIntegrationOAuth().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling startGoogleDataIntegrationOAuth().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/google-data-integration/{integrationId}/oauth`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Creates a one-use project and integration bound Google OAuth authorization URL. Superadministrator only.
     */
    async startGoogleDataIntegrationOAuthRaw(requestParameters: StartGoogleDataIntegrationOAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleOAuthAuthorizationData>> {
        const requestOptions = await this.startGoogleDataIntegrationOAuthRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleOAuthAuthorizationDataFromJSON(jsonValue));
    }

    /**
     * Creates a one-use project and integration bound Google OAuth authorization URL. Superadministrator only.
     */
    async startGoogleDataIntegrationOAuth(requestParameters: StartGoogleDataIntegrationOAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleOAuthAuthorizationData> {
        const response = await this.startGoogleDataIntegrationOAuthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for transitionGoogleDataSourceOwnership without sending the request
     */
    async transitionGoogleDataSourceOwnershipRequestOpts(requestParameters: TransitionGoogleDataSourceOwnershipRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling transitionGoogleDataSourceOwnership().'
            );
        }

        if (requestParameters['googleFactOwnershipTransitionInput'] == null) {
            throw new runtime.RequiredError(
                'googleFactOwnershipTransitionInput',
                'Required parameter "googleFactOwnershipTransitionInput" was null or undefined when calling transitionGoogleDataSourceOwnership().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-data/source-ownership/transition`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GoogleFactOwnershipTransitionInputToJSON(requestParameters['googleFactOwnershipTransitionInput']),
        };
    }

    /**
     * Explicit effective-dated primary publisher transition after an accepted shadow comparison. It never disconnects either integration.
     */
    async transitionGoogleDataSourceOwnershipRaw(requestParameters: TransitionGoogleDataSourceOwnershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleFactOwnershipTransitionData>> {
        const requestOptions = await this.transitionGoogleDataSourceOwnershipRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleFactOwnershipTransitionDataFromJSON(jsonValue));
    }

    /**
     * Explicit effective-dated primary publisher transition after an accepted shadow comparison. It never disconnects either integration.
     */
    async transitionGoogleDataSourceOwnership(requestParameters: TransitionGoogleDataSourceOwnershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleFactOwnershipTransitionData> {
        const response = await this.transitionGoogleDataSourceOwnershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateGoogleMerchantMarketReportSettings without sending the request
     */
    async updateGoogleMerchantMarketReportSettingsRequestOpts(requestParameters: UpdateGoogleMerchantMarketReportSettingsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateGoogleMerchantMarketReportSettings().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling updateGoogleMerchantMarketReportSettings().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling updateGoogleMerchantMarketReportSettings().'
            );
        }

        if (requestParameters['updateGoogleMerchantMarketReportSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateGoogleMerchantMarketReportSettingsRequest',
                'Required parameter "updateGoogleMerchantMarketReportSettingsRequest" was null or undefined when calling updateGoogleMerchantMarketReportSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-merchant/{integrationId}/accounts/{accountId}/market-report-settings`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));
        urlPath = urlPath.replace('{accountId}', encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGoogleMerchantMarketReportSettingsRequestToJSON(requestParameters['updateGoogleMerchantMarketReportSettingsRequest']),
        };
    }

    /**
     */
    async updateGoogleMerchantMarketReportSettingsRaw(requestParameters: UpdateGoogleMerchantMarketReportSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleMerchantAccountData>> {
        const requestOptions = await this.updateGoogleMerchantMarketReportSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleMerchantAccountDataFromJSON(jsonValue));
    }

    /**
     */
    async updateGoogleMerchantMarketReportSettings(requestParameters: UpdateGoogleMerchantMarketReportSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleMerchantAccountData> {
        const response = await this.updateGoogleMerchantMarketReportSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for upgatesIntegration without sending the request
     */
    async upgatesIntegrationRequestOpts(requestParameters: UpgatesIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling upgatesIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/upgates`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgatesIntegrationInputToJSON(requestParameters['upgatesIntegrationInput']),
        };
    }

    /**
     * Create or update Upgates integration.
     */
    async upgatesIntegrationRaw(requestParameters: UpgatesIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpgatesIntegrationData>> {
        const requestOptions = await this.upgatesIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgatesIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Upgates integration.
     */
    async upgatesIntegration(requestParameters: UpgatesIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpgatesIntegrationData> {
        const response = await this.upgatesIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for validateAndSelectGoogleBigQueryGA4ExportRecipe without sending the request
     */
    async validateAndSelectGoogleBigQueryGA4ExportRecipeRequestOpts(requestParameters: ValidateAndSelectGoogleBigQueryGA4ExportRecipeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling validateAndSelectGoogleBigQueryGA4ExportRecipe().'
            );
        }

        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling validateAndSelectGoogleBigQueryGA4ExportRecipe().'
            );
        }

        if (requestParameters['googleBigQueryRecipeInput'] == null) {
            throw new runtime.RequiredError(
                'googleBigQueryRecipeInput',
                'Required parameter "googleBigQueryRecipeInput" was null or undefined when calling validateAndSelectGoogleBigQueryGA4ExportRecipe().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/google-bigquery/{integrationId}/ga4-export-recipe`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GoogleBigQueryRecipeInputToJSON(requestParameters['googleBigQueryRecipeInput']),
        };
    }

    /**
     * Validates the fixed GA4 export schema using table metadata and a capped dry-run before storing the only supported recipe.
     */
    async validateAndSelectGoogleBigQueryGA4ExportRecipeRaw(requestParameters: ValidateAndSelectGoogleBigQueryGA4ExportRecipeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GoogleBigQueryRecipeValidationData>> {
        const requestOptions = await this.validateAndSelectGoogleBigQueryGA4ExportRecipeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GoogleBigQueryRecipeValidationDataFromJSON(jsonValue));
    }

    /**
     * Validates the fixed GA4 export schema using table metadata and a capped dry-run before storing the only supported recipe.
     */
    async validateAndSelectGoogleBigQueryGA4ExportRecipe(requestParameters: ValidateAndSelectGoogleBigQueryGA4ExportRecipeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GoogleBigQueryRecipeValidationData> {
        const response = await this.validateAndSelectGoogleBigQueryGA4ExportRecipeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for zboziIntegration without sending the request
     */
    async zboziIntegrationRequestOpts(requestParameters: ZboziIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling zboziIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/integrations/zbozi`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ZboziIntegrationInputToJSON(requestParameters['zboziIntegrationInput']),
        };
    }

    /**
     * Create or update Zbozi integration.
     */
    async zboziIntegrationRaw(requestParameters: ZboziIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ZboziIntegrationData>> {
        const requestOptions = await this.zboziIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ZboziIntegrationDataFromJSON(jsonValue));
    }

    /**
     * Create or update Zbozi integration.
     */
    async zboziIntegration(requestParameters: ZboziIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ZboziIntegrationData> {
        const response = await this.zboziIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GoogleAnalyticsAggregateReportRecipeEnum = {
    Acquisition: 'acquisition',
    Daily: 'daily',
    LandingPage: 'landing-page',
    Page: 'page',
    Device: 'device',
    Geography: 'geography',
    DemographicAge: 'demographic-age',
    DemographicGender: 'demographic-gender',
    DemographicInterest: 'demographic-interest',
    EcommerceEvent: 'ecommerce-event',
    Product: 'product',
    Transaction: 'transaction'
} as const;
export type GoogleAnalyticsAggregateReportRecipeEnum = typeof GoogleAnalyticsAggregateReportRecipeEnum[keyof typeof GoogleAnalyticsAggregateReportRecipeEnum];
/**
 * @export
 */
export const GoogleMerchantCatalogueProductsSortByEnum = {
    OfferId: 'offerId',
    Title: 'title',
    Brand: 'brand',
    Availability: 'availability',
    Price: 'price',
    SalePrice: 'salePrice',
    Issues: 'issues',
    Disapproved: 'disapproved',
    Mapped: 'mapped'
} as const;
export type GoogleMerchantCatalogueProductsSortByEnum = typeof GoogleMerchantCatalogueProductsSortByEnum[keyof typeof GoogleMerchantCatalogueProductsSortByEnum];
/**
 * @export
 */
export const GoogleMerchantCatalogueProductsSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GoogleMerchantCatalogueProductsSortDirectionEnum = typeof GoogleMerchantCatalogueProductsSortDirectionEnum[keyof typeof GoogleMerchantCatalogueProductsSortDirectionEnum];
/**
 * @export
 */
export const GoogleSearchConsoleReportRecipeEnum = {
    Total: 'total',
    Page: 'page',
    Query: 'query',
    Country: 'country',
    Device: 'device',
    SearchAppearance: 'search-appearance',
    SearchType: 'search-type'
} as const;
export type GoogleSearchConsoleReportRecipeEnum = typeof GoogleSearchConsoleReportRecipeEnum[keyof typeof GoogleSearchConsoleReportRecipeEnum];
/**
 * @export
 */
export const InstallGoogleDataIntegrationTypeEnum = {
    Merchant: 'merchant',
    Analytics: 'analytics',
    SearchConsole: 'search-console',
    Bigquery: 'bigquery'
} as const;
export type InstallGoogleDataIntegrationTypeEnum = typeof InstallGoogleDataIntegrationTypeEnum[keyof typeof InstallGoogleDataIntegrationTypeEnum];
